import { RefObject, useEffect, useState } from 'react';

export function useScrollTracking(ref: RefObject<HTMLElement>, value: any) {
  const [isScrollable, setIsScrollable] = useState(false);
  const [canScrollRight, setCanScrollRight] = useState(false);
  const [canScrollLeft, setCanScrollLeft] = useState(false);

  const updateScrollState = () => {
    if (ref.current) {
      const { scrollWidth, clientWidth, scrollLeft } = ref.current;
      setIsScrollable(scrollWidth > clientWidth);
      setCanScrollRight(scrollLeft + clientWidth < scrollWidth - 1);
      setCanScrollLeft(scrollLeft > 1);
    }
  };

  useEffect(() => {
    updateScrollState();

    const currentRef = ref.current;
    window.addEventListener('resize', updateScrollState);
    currentRef?.addEventListener('scroll', updateScrollState);
    currentRef?.addEventListener('resize', updateScrollState);

    return () => {
      window.removeEventListener('resize', updateScrollState);
      currentRef?.removeEventListener('scroll', updateScrollState);
      currentRef?.removeEventListener('resize', updateScrollState);
    };
  }, [ref]);

  useEffect(() => {
    updateScrollState();
  }, [value]);

  return { isScrollable, canScrollRight, canScrollLeft };
}
